import React from 'react';
import { NavLink } from 'react-router-dom';

// Icons as inline SVG for zero dependency
const HomeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
    <polyline points="9,22 9,12 15,12 15,22"/>
  </svg>
);

const ListIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
    <line x1="8" y1="6" x2="21" y2="6"/>
    <line x1="8" y1="12" x2="21" y2="12"/>
    <line x1="8" y1="18" x2="21" y2="18"/>
    <line x1="3" y1="6" x2="3.01" y2="6"/>
    <line x1="3" y1="12" x2="3.01" y2="12"/>
    <line x1="3" y1="18" x2="3.01" y2="18"/>
  </svg>
);

const PiggyIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
    <path d="M19 12a7 7 0 10-14 0"/>
    <path d="M12 5v2M5 12H3M21 12h-2"/>
    <circle cx="12" cy="12" r="3"/>
    <path d="M12 19v3M8 21l2-2M16 21l-2-2"/>
  </svg>
);

const HistoryIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <polyline points="12,6 12,12 16,14"/>
  </svg>
);

const SettingsIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3"/>
    <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/>
  </svg>
);

export const StudentNav = () => (
  <nav className="bottom-nav">
    <NavLink to="/" end className={({ isActive }) => `nav-item${isActive ? ' nav-item--active' : ''}`}>
      <HomeIcon />
      <span>Home</span>
    </NavLink>
    <NavLink to="/transactions" className={({ isActive }) => `nav-item${isActive ? ' nav-item--active' : ''}`}>
      <ListIcon />
      <span>History</span>
    </NavLink>
    <NavLink to="/savings" className={({ isActive }) => `nav-item${isActive ? ' nav-item--active' : ''}`}>
      <PiggyIcon />
      <span>Savings</span>
    </NavLink>
    <NavLink to="/settings" className={({ isActive }) => `nav-item${isActive ? ' nav-item--active' : ''}`}>
      <SettingsIcon />
      <span>Settings</span>
    </NavLink>
  </nav>
);

export const ParentNav = () => (
  <nav className="bottom-nav">
    <NavLink to="/" end className={({ isActive }) => `nav-item${isActive ? ' nav-item--active' : ''}`}>
      <HomeIcon />
      <span>Overview</span>
    </NavLink>
    <NavLink to="/history" className={({ isActive }) => `nav-item${isActive ? ' nav-item--active' : ''}`}>
      <HistoryIcon />
      <span>History</span>
    </NavLink>
    <NavLink to="/settings" className={({ isActive }) => `nav-item${isActive ? ' nav-item--active' : ''}`}>
      <SettingsIcon />
      <span>Settings</span>
    </NavLink>
  </nav>
);
